import * as auth from './services/auth';
import * as user from './services/user';
import * as contacts from './services/contacts';
import * as events from './services/events';
import * as organization from './services/organization';
import * as partner from './services/partner';
import * as material from './services/material';
import * as scanpoint from './services/scanPoint';
import * as notifications from './services/notifications'
import * as shop from './services/shop'
import * as person from './services/person'
import * as support from './services/support';
import * as mobile from './services/mobile';
import * as email from './services/email'
import * as analytics from './services/analytics';

const api = {
  auth,
  user,
  contacts,
  events,
  organization,
  partner,
  material,
  scanpoint,
  notifications,
  shop,
  person,
  support,
  mobile,
  email,
  analytics
};

export default api;
